export const LAW_LINK =
  'http://ips.pravo.gov.ru/?docbody=&link_id=3&nd=102560688&intelsearch=';
